/* eslint-disable no-undef */
/* eslint-disable no-unused-expressions */
import { LOGGED_IN_USER, LOGIN_USER, LOGOUT_USER, REFRESH_USER } from '../actions';
import ApiManager from '../../ApiManager/ApiManager';
import { Manager } from '../../StorageManager/Storage';
import { loginUserError, loginUserSuccess, changeLoading, setRefreshUser } from './actions';
import { call, all, fork, takeEvery, put } from 'redux-saga/effects';
import APIURLS from '../../ApiManager/apiUrl';
import { store } from '../../index';
import GPSinaApis from '../../ApiManager/GPSinaApis';

const api = ApiManager.getInstance();
export function* watchLoginUser() {
    yield takeEvery(LOGIN_USER, loginToServer);
}
export function* watchLoggedInUser() {
    yield takeEvery(LOGGED_IN_USER, handleLoggedInUser);
}

export function* watchRefreshUser() {
    yield takeEvery(REFRESH_USER, refreshUser);
}

function* loginToServer({ payload }) {
    const { body, history, onSuccess } = payload;
    try {
        const response = yield call(body.isPin ? asyncLoginPin : asyncLogin, body);
        const success = { 7011: true, 7045: true, 2003: true, 8056: true }
        if (success[response.data.code]) {
            if (response.data.code == 8056) yield call(setAuthorization, response.data.data.userId, response.data.data.token);
            if (onSuccess) return onSuccess(response.data);
            const userResponse = yield call(getUser);
            if (userResponse.data.code === 1004) {
                Manager.setItem('token', response.data.data.token);
                Manager.setItem('user', userResponse.data.data);
                yield put(
                    loginUserSuccess(
                        response.data.data.token,
                        userResponse.data.data,
                    ),
                );
                history.push('/');
            } else {
                yield put(loginUserError(userResponse.data.message));
            }
        } else {
            yield put(loginUserError(response.data.message));
        }
    } catch (error) {
        yield put(loginUserError(error.message));
    }
}

function* handleLoggedInUser({ payload }) {
    try {
        const userResponse = yield call(getUser);
        if (userResponse.data.code === 1004) {
            const { history, token } = payload;
            Manager.setItem('token', token);
            Manager.setItem('user', userResponse.data.data);
            yield put(
                loginUserSuccess(
                    token,
                    userResponse.data.data,
                ),
            );
            history.push('/');
        } else {
            yield put(loginUserError(userResponse.data.message));
        }
    } catch (error) {
        yield put(loginUserError(error.message));
    }
}

function* refreshUser() {
    try {
        const userResponse = yield call(getUser);
        if (userResponse.data.code === 1004) {
            Manager.setItem('user', userResponse.data.data);
            yield put(setRefreshUser(userResponse.data.data));
        }
    } catch (error) {
        yield put(loginUserError(error.message));
    }
}

const asyncLogin = async body =>
    await GPSinaApis.login(body);

const asyncLoginPin = async body =>
    await GPSinaApis.loginPin(body)

const getUser = async () =>
    await GPSinaApis.getUser()

const logoutApi = async () =>
    await GPSinaApis.logout()

const setAuthorization = async (email, token) =>
    await api.setToken(email, token);

export function* watchLogoutUser() {
    yield takeEvery(LOGOUT_USER, logout);
}

function* logout({ payload }) {
    try {
        Manager.removeItem('sessionId');
        Manager.removeItem('user');
        Manager.removeItem('token');
        payload.history.push('/');
        store.dispatch(changeLoading(true));
    } catch (e) {
        console.log('e', JSON.stringify(e.message, null, 2));
    }
}

export default function* rootSaga() {
    yield all([fork(watchLoginUser), fork(watchLogoutUser), fork(watchLoggedInUser), fork(watchRefreshUser)]);
}
